import { Reducer } from 'redux';

import { IExportState, ExportTypes } from './Types';


let initialState: IExportState = {
    file: null,
    user_id: null,
    file_name: null,
    filters: null
};


const reducer: Reducer<IExportState> = (state = initialState, action) => {
    switch (action.type) {
        case ExportTypes.GET_EXPORT: {
            return {
                ...state,
                file: null
            };
        }
        case ExportTypes.GET_EXPORT_SUCCESS: {
            return{
                ...state,
                file: action.payload.results
            }
        }
        case ExportTypes.GET_EXPORT_ERROR: {
            return {
                ...state
            }
        }
        case ExportTypes.CLEAN_FILE: {
            return {
                ...state,
                file: null
            }
        }
        case ExportTypes.SET_EXPORT_FILE: {
            return {
                ...state,
                file: action.payload
            }
        }
        default: {
            return state;
        }
    }
};

export { reducer as ExportReducer };